import { useContext, useState } from "react";
import "../styles/portal/Signin.css"
import { NavLink, useNavigate } from "react-router-dom";
import { signIn } from "../aws/Authentication";
import { PortalContext } from "../Portal";

function Signin() {    
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { setUser } = useContext(PortalContext);
  const [alertVisible, setAlertVisibility] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    signIn(email, password)
      .then((data) => {
        setUser(data);
        // console.log("signIn.then data = ", data);
        navigate("/portal/home");
      })
      .catch((err) => {
        console.log(err.message);
        setErrorMessage(err.message);
        setAlertVisibility(true);
      });
    // navigate("/portal/home");
  };

    return (
      <div className="signin-container">
        <h3>Faça login</h3>
        <form className="signin-form" onSubmit={handleSubmit}>
          <label>E-mail:</label>
          <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          />
          <label>Senha:</label>
          <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          />
          <NavLink className="signin-form-navlink">Esqueceu sua senha?</NavLink>
          <input type="submit" value="Entrar"></input>
          {alertVisible && <h3 className="signin-form-navlink">{errorMessage}</h3>}
          <label>Ainda não é registrado?</label>
          <NavLink className="signin-form-navlink" to={"/portal/signup"}>Registre-se</NavLink>
        </form>
      </div>
    )
}

export default Signin;
